"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('financing', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    fillRule: "nonzero",
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("circle", {
    stroke: props.outStrokeColor,
    fill: props.outFillColor,
    cx: "20",
    cy: "20",
    r: "20"
  }), _react.default.createElement("path", {
    d: "M17.5638852,15 L22.4361148,15 C23.3276335,15 23.6509198,15.0928256 23.9768457,15.2671327 C24.3027716,15.4414398 24.5585602,15.6972284 24.7328673,16.0231543 C24.9071744,16.3490802 25,16.6723665 25,17.5638852 L25,22.4361148 C25,23.3276335 24.9071744,23.6509198 24.7328673,23.9768457 C24.5585602,24.3027716 24.3027716,24.5585602 23.9768457,24.7328673 C23.6509198,24.9071744 23.3276335,25 22.4361148,25 L17.5638852,25 C16.6723665,25 16.3490802,24.9071744 16.0231543,24.7328673 C15.6972284,24.5585602 15.4414398,24.3027716 15.2671327,23.9768457 C15.0928256,23.6509198 15,23.3276335 15,22.4361148 L15,17.5638852 C15,16.6723665 15.0928256,16.3490802 15.2671327,16.0231543 C15.4414398,15.6972284 15.6972284,15.4414398 16.0231543,15.2671327 C16.3490802,15.0928256 16.6723665,15 17.5638852,15 Z",
    stroke: props.innerStrokeColor,
    fill: props.innerFillColor,
    transform: "translate(20.000000, 20.000000) rotate(45.000000) translate(-20.000000, -20.000000) "
  }))));
});

exports.default = _default;